import { PaymentMethod } from 'models/ChargeIntent'
import { PaymentSource } from 'models/Transaction'
import { RootState } from 'redux/store'

const getPaymentSource = (type: PaymentMethod, store: RootState) => {
  let paymentSource = null

  switch (type) {
    case PaymentMethod.Stripe:
    case PaymentMethod.CC:
    case PaymentMethod.ACH:
      paymentSource = PaymentSource.MANUAL
      break
    case PaymentMethod.Plaid:
      paymentSource = PaymentSource.PLAID
      break
    case PaymentMethod.DW:
      const walletType = store.order.pmStatus.digitalWallets.walletType
      paymentSource = walletType ? PaymentSource[walletType] : PaymentSource.WALLET
      break
    case PaymentMethod.PayPal:
    case PaymentMethod.PayPal_Commerce:
      paymentSource = PaymentSource.PAYPAL
      break
    case PaymentMethod.Venmo:
      paymentSource = PaymentSource.VENMO
      break
    default:
      paymentSource = PaymentSource[type] ?? null
      break
  }

  return paymentSource
}

export default getPaymentSource
